import { Accordion, AccordionSummary, Box, Button, Switch } from '@material-ui/core';
import { Delete, UnfoldMore } from '@material-ui/icons';

export const RatingControl = ({ onUpdate, value, onDelete }) => {
    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={false}>
                <AccordionSummary
                    className='handle'
                    expandIcon={<Button
                        size="small"
                        variant='contained'
                        onClick={() => onDelete()}
                        startIcon={<Delete />}
                        color='default'>
                        Remove
                    </Button>}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.69912 1.57586C9.95123 0.800065 11.0488 0.800065 11.3009 1.57587L13.0053 6.82097C13.1181 7.16791 13.4414 7.4028 13.8062 7.40282L19.3213 7.40303C20.137 7.40306 20.4762 8.44689 19.8162 8.92639L15.3546 12.1683C15.0594 12.3827 14.936 12.7628 15.0487 13.1097L16.7527 18.3549C17.0048 19.1308 16.1168 19.7759 15.4569 19.2964L10.995 16.0549C10.6998 15.8405 10.3002 15.8405 10.005 16.0549L5.54312 19.2964C4.88316 19.7759 3.99522 19.1308 4.24727 18.3549L5.95133 13.1097C6.06405 12.7628 5.94055 12.3827 5.64543 12.1683L1.18375 8.92639C0.523825 8.44689 0.862987 7.40306 1.67872 7.40303L7.19382 7.40282C7.55861 7.4028 7.88192 7.16791 7.99466 6.82097L9.69912 1.57586Z" stroke="#CECECE" stroke-width="1.26316" />
                            </svg>
                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Rating
                        </div>
                    </Box>
                </AccordionSummary>
            </Accordion>
        </div>
    )
}
